import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';
import { z } from 'zod';

export const loginPasswordEditRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/password/edit',
  validateSearch: z.object({
    reset_password_token: z.string().optional(),
  }),
}).lazy(() => import('pages/shared/EditPassword/EditPassword').then((d) => d.Route));
